module.exports = __webpack_public_path__ + "public/StoreIcon/store-profile-default.svg?ce59b2e6";